import * as THREE from "three";
import occtimportjs from "occt-import-js";

/** 仅 3D 相关页面使用，避免 three/occt 被全站拉取导致卡顿 */
export async function LoadStep(fileUrl: string, buffer?: ArrayBuffer) {
	const wasmUrl = "/3DModals/occt-import-js.wasm";
	const targetObject = new THREE.Object3D();
	const occt = await occtimportjs({
		locateFile: (name: string) => wasmUrl,
	});

	if (!buffer) {
		const response = await fetch(fileUrl);
		buffer = await response.arrayBuffer();
	}
	const fileBuffer = new Uint8Array(buffer);
	const result = occt.ReadStepFile(fileBuffer, null as any);
	for (const resultMesh of result.meshes) {
		const geometry = new THREE.BufferGeometry();
		geometry.setAttribute(
			"position",
			new THREE.Float32BufferAttribute(resultMesh.attributes.position.array, 3),
		);
		if (resultMesh.attributes.normal) {
			geometry.setAttribute(
				"normal",
				new THREE.Float32BufferAttribute(resultMesh.attributes.normal.array, 3),
			);
		}
		const index = Uint16Array.from(resultMesh.index.array);
		geometry.setIndex(new THREE.BufferAttribute(index, 1));
		const material = resultMesh.color
			? new THREE.MeshPhongMaterial({
					color: new THREE.Color(resultMesh.color[0], resultMesh.color[1], resultMesh.color[2]),
				})
			: new THREE.MeshPhongMaterial({ color: 0xaaaaaa });
		targetObject.add(new THREE.Mesh(geometry, material));
	}
	return targetObject;
}
